import { getSelectedTableView } from 'owa-mail-list-store';
import { isPublicFolder } from 'owa-folders';
/**
 * Checks if selected row in left nav is public folder
 */
export function isPublicFolderSelected() {
    var selectedTable = getSelectedTableView();
    return (selectedTable &&
        selectedTable.tableQuery.type == 0 /* Folder */ &&
        isPublicFolder(selectedTable.tableQuery.folderId));
}
/**
 * Gets folderId from a specified row in left nav
 */
export function getSelectedPublicFolderId() {
    var tableView = getSelectedTableView();
    return tableView &&
        tableView.tableQuery.type == 0 /* Folder */ &&
        isPublicFolder(tableView.tableQuery.folderId)
        ? tableView.tableQuery.folderId
        : null;
}
//# sourceMappingURL=isPublicFolderSelected.js.map